import { render, staticRenderFns } from "./v-header.vue?vue&type=template&id=07bbe1aa&"
import script from "./v-header.vue?vue&type=script&lang=js&"
export * from "./v-header.vue?vue&type=script&lang=js&"
import style0 from "./v-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports